import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const DesalinationPlants: React.FC = () => {
  return (
    <>
      <PageHeader title="Desalination Plants" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-12">
                  <img className="img-fluid" src="img/desalination-plant.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Desalination Plants</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Desalination Plants use advanced membrane or thermal technologies to convert saline or seawater into freshwater that is safe and usable for industrial, municipal, or potable applications. At Wasser Technochem (India) Ltd., we specialize in membrane-based desalination (SWRO) systems that are energy-efficient, compact, and tailored to suit India's diverse water scarcity challenges.</p>
              <p>Desalination is a critical solution for coastal industries, island municipalities, and drought-prone regions, helping reduce dependence on freshwater reserves and ensure long-term water security.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-industry text-primary me-2"></i>Industrial use in power, steel, cement, and refineries</p>
              <p><i className="fa fa-city text-primary me-2"></i>Municipal drinking water schemes in coastal and arid areas</p>
              <p><i className="fa fa-building text-primary me-2"></i>Smart cities and SEZs with non-available freshwater sources</p>
              <p><i className="fa fa-ship text-primary me-2"></i>Resorts, marine operations, and off-grid facilities</p>
              <p><i className="fa fa-seedling text-primary me-2"></i>Agriculture and irrigation in saline groundwater areas</p>

              <h3 className="mb-4">Our Capabilities</h3>
              <p className="mb-4">WTIL offers turnkey SWRO (Seawater Reverse Osmosis) systems, from feedwater analysis and pilot testing to detailed engineering, execution, and O&M.</p>
              
              <div className="mb-4">
                <h5><i className="fa fa-water text-primary me-2"></i>Modular SWRO Plants (up to 10 MLD and beyond)</h5>
                <p className="ms-4">Designed for seawater and brackish water desalination.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-bolt text-primary me-2"></i>High-Pressure Pumps & Energy Recovery Devices</h5>
                <p className="ms-4">Reduces energy consumption and improves lifecycle performance.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-shield-alt text-primary me-2"></i>Corrosion-Resistant Materials: SS 316, Duplex Steel, HDPE</h5>
                <p className="ms-4">To withstand high TDS and marine conditions.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-filter text-primary me-2"></i>Pre-treatment Systems (UF, MGF, ACF, antiscalants)</h5>
                <p className="ms-4">Customized to reduce membrane fouling and scaling.</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-balance-scale text-primary me-2"></i>Post-Treatment & Blending Systems</h5>
                <p className="ms-4">To adjust pH, add minerals, and meet potable water norms (IS 10500).</p>
              </div>

              <div className="mb-4">
                <h5><i className="fa fa-desktop text-primary me-2"></i>Automation with Remote Monitoring</h5>
                <p className="ms-4">SCADA-based control panels with real-time performance analytics.</p>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Converts seawater into reliable freshwater at scale</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compact, modular systems for rapid deployment</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Ideal for water-stressed industrial or coastal regions</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compliant with BIS and WHO water quality standards</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Decades of experience in membrane desalination and high-TDS applications</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house team for marine-grade fabrication, logistics, and commissioning</p>
              <p><i className="fa fa-star text-warning me-2"></i>Proven track record in coastal desalination, smart cities, and industrial clusters</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Sustainable water source enabling ESG compliance</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default DesalinationPlants;
